import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useIsMobile } from '../../utils/useIsMobile';

const PRIMARY = '#3eb574';

const Footer: React.FC = () => {
  const mobile = useIsMobile();
  const [openCol, setOpenCol] = useState<string | null>(null);

  const cols: Array<{ title: string; links: [string, string][] }> = [
    { title: '产品', links: [['功能介绍', '/features'], ['价格方案', '/pricing'], ['客户案例', '/cases']] },
    { title: '支持', links: [['帮助中心', '/faq'], ['联系我们', '/faq']] },
    { title: '公司', links: [['关于我们', '/'], ['隐私政策', '/'], ['服务条款', '/']] },
  ];

  const platformIcons = [
    '/assets/images/logo/wx.png',
    '/assets/images/logo/alipay.png',
    '/assets/images/logo/titok.png',
    '/assets/images/logo/xhs.png',
  ];

  return (
    <footer style={{
      background: '#0f172a',
      color: '#94a3b8',
      paddingTop: mobile ? 40 : 64,
      paddingBottom: `calc(${mobile ? 24 : 40}px + env(safe-area-inset-bottom, 0px))`,
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: mobile ? '0 20px' : '0 24px' }}>
        {mobile ? (
          <>
            <div style={{ marginBottom: 28 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <img src="/assets/images/logo.jpg" style={{ width: 32, height: 32, borderRadius: 8 }} alt="佳达掌柜" />
                <span style={{ color: 'white', fontWeight: 700, fontSize: 15 }}>佳达掌柜</span>
              </div>
              <p style={{ fontSize: 13, lineHeight: 1.7, margin: 0 }}>好用的店铺经营助手，助力 1000+ 商家数字化经营。</p>
              <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
                {platformIcons.map((src, i) => (
                  <div key={i} style={{ width: 30, height: 30, background: '#1e293b', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 5 }}>
                    <img src={src} style={{ width: '100%', height: '100%', objectFit: 'contain' }} alt="" />
                  </div>
                ))}
              </div>
            </div>

            <div style={{ borderTop: '1px solid #1e293b', marginBottom: 24 }}>
              {cols.map(col => {
                const isOpen = openCol === col.title;
                return (
                  <div key={col.title} style={{ borderBottom: '1px solid #1e293b' }}>
                    <button
                      onClick={() => setOpenCol(isOpen ? null : col.title)}
                      aria-expanded={isOpen}
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '14px 0',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: 'white',
                        fontSize: 14,
                        fontWeight: 600,
                      }}
                    >
                      <span>{col.title}</span>
                      <span
                        style={{
                          display: 'inline-block',
                          width: 10,
                          height: 10,
                          borderRight: '1.5px solid #94a3b8',
                          borderBottom: '1.5px solid #94a3b8',
                          transform: isOpen ? 'rotate(-135deg) translate(-2px,-2px)' : 'rotate(45deg)',
                          transition: 'transform 0.2s',
                        }}
                      />
                    </button>
                    {isOpen && (
                      <div style={{ paddingBottom: 12 }}>
                        {col.links.map(([label, href]) => (
                          <Link
                            key={label}
                            to={href}
                            style={{ display: 'block', padding: '8px 0', color: '#94a3b8', fontSize: 14, textDecoration: 'none' }}
                          >
                            {label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24, padding: '16px 0', borderBottom: '1px solid #1e293b' }}>
              <img
                src="/assets/images/qrcode.jpg"
                style={{ width: 80, height: 80, borderRadius: 12, border: '2px solid #1e293b', flexShrink: 0 }}
                alt="扫码体验"
              />
              <div>
                <div style={{ color: 'white', fontWeight: 600, fontSize: 14, marginBottom: 4 }}>扫码体验</div>
                <p style={{ fontSize: 12, margin: 0, lineHeight: 1.6 }}>微信扫码<br />免费试用 14 天</p>
              </div>
            </div>

            <div style={{ paddingTop: 16, fontSize: 11, lineHeight: 1.7, color: '#64748b' }}>
              <div>© 2020–{new Date().getFullYear()} 上海天工明理信息技术有限公司</div>
              <div>沪ICP备2024104469号-1 · 隐私政策 · 服务条款</div>
            </div>
          </>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 40, marginBottom: 48 }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                  <img src="/assets/images/logo.jpg" style={{ width: 36, height: 36, borderRadius: 10 }} alt="佳达掌柜" />
                  <span style={{ color: 'white', fontWeight: 700, fontSize: 16 }}>佳达掌柜</span>
                </div>
                <p style={{ fontSize: 14, lineHeight: 1.7, maxWidth: 200 }}>好用的店铺经营助手，助力1000+商家数字化经营。</p>
                <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
                  {platformIcons.map((src, i) => (
                    <div key={i} style={{ width: 32, height: 32, background: '#1e293b', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 6 }}>
                      <img src={src} style={{ width: '100%', height: '100%', objectFit: 'contain' }} alt="" />
                    </div>
                  ))}
                </div>
              </div>

              {cols.map(col => (
                <div key={col.title}>
                  <div style={{ color: 'white', fontWeight: 600, fontSize: 14, marginBottom: 16 }}>{col.title}</div>
                  {col.links.map(([label, href]) => (
                    <div key={label} style={{ marginBottom: 10 }}>
                      <Link
                        to={href}
                        style={{ color: '#94a3b8', fontSize: 14, textDecoration: 'none', transition: 'color 0.15s' }}
                        onMouseEnter={e => (e.currentTarget.style.color = PRIMARY)}
                        onMouseLeave={e => (e.currentTarget.style.color = '#94a3b8')}
                      >
                        {label}
                      </Link>
                    </div>
                  ))}
                </div>
              ))}

              <div>
                <div style={{ color: 'white', fontWeight: 600, fontSize: 14, marginBottom: 16 }}>扫码体验</div>
                <img
                  src="/assets/images/qrcode.jpg"
                  style={{ width: 96, height: 96, borderRadius: 16, border: '3px solid #1e293b' }}
                  alt="扫码体验"
                />
                <p style={{ fontSize: 12, marginTop: 10 }}>微信扫码，免费试用</p>
              </div>
            </div>

            <div style={{ borderTop: '1px solid #1e293b', paddingTop: 24, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 12 }}>
              <span style={{ fontSize: 13 }}>© 2020–{new Date().getFullYear()} 上海天工明理信息技术有限公司 · 沪ICP备2024104469号-1</span>
              <span style={{ fontSize: 13 }}>隐私政策 · 服务条款</span>
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default Footer;
